import { atom } from "jotai";

export interface IWarehouse {
    id?: number;
    name: string;
    description?: string | null;
    width?: number | null;
    height?: number | null;
    length?: number | null;
}

export interface IWarehouseInput extends Omit<IWarehouse, 'id'> {}

export const warehousesAtom = atom<IWarehouse[]>([]);
export const warehousesLoadingAtom = atom<boolean>(false);

